import { render, staticRenderFns } from "./Hero.vue?vue&type=template&id=74efd1a2&scoped=true&"
var script = {}
import style0 from "./Hero.vue?vue&type=style&index=0&id=74efd1a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74efd1a2",
  null
  
)

export default component.exports